/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardVulnerabilityAccountDetails {
    getFixupPrototypeFunction() { return SecurityDashboardVulnerabilityAccountDetails.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardVulnerabilityAccountDetails>): SecurityDashboardVulnerabilityAccountDetails {
        let obj = Object.assign(new SecurityDashboardVulnerabilityAccountDetails(), model);
        SecurityDashboardVulnerabilityAccountDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardVulnerabilityAccountDetails>): SecurityDashboardVulnerabilityAccountDetails {
        if (!model) return null;
        return SecurityDashboardVulnerabilityAccountDetails.newInstance(<SecurityDashboardVulnerabilityAccountDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardVulnerabilityAccountDetails) {
        if (!obj) return;

        models.SecurityDashboardVulnerabilityAccountDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardVulnerabilityAccountDetails): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardVulnerabilityAccountDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count_by_severity) {
            models.SecurityDashboardSeverity.fixupPrototype(this.count_by_severity);
        }
    }

    /**
     * Tenant value
     */
    tenant_id: string;

    /**
     * Cloud Account value
     */
    cloud_account_id: string;

    /**
     * Service Account Name
     */
    service_account_name: string;

    /**
     * Visibility for the Cloud Provider
     */
    cloud_provider: models.CloudServiceName;

    /**
     * Vulnerability Severity Values
     */
    count_by_severity: models.SecurityDashboardSeverity;

}
